import * as React from "react";
import {Video} from "@models/video-content";
import { Rate , Table} from "antd";
import {FormattedMessage, intlShape} from "react-intl";
import './index.scss'
import __i18n from "../../../intl/__i18n";
import {getFormattedPrice} from "../../../utils";


type Props = {
  data: Video[];
  loading: boolean;
  deleteFn: (item: Video) => void;
  intl: intlShape.isRequired;
  currentPage: number;
};

const ReportList: React.FC<Props> = props => {
  const {data, loading} = props;
  
  const columns = [
    {
      title: <FormattedMessage id="app.index" defaultMessage={`Index`}/>,
      width: 30,
      dataIndex: "id",
      key: "id",
      render: (a, b, i) => <span>{i + 1 }</span>
    },
    {
      title: <FormattedMessage id="app.title" defaultMessage={`Title`}/>,
      align:"right",
      dataIndex: "title",
      key: "title",
    },
    {
      title: __i18n("Sum Price"),
      dataIndex: "sum_price",
      align:"right",
      key: "sum_price",
      render: (sum_price) => getFormattedPrice(sum_price)
    },
    {
      title: <FormattedMessage id="app.click_count" defaultMessage={`Click Count`}/>,
      dataIndex: "click_count",
      align:"left",
      key: "click_count",
    },
  ];
  
  return (
    <Table
      className={'report-table'}
      columns={columns}
      loading={loading}
      pagination={false}
      dataSource={data}
      rowKey="id"
    />
  );
};

export default ReportList;
